import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  IonCard,
  IonCardContent,
  IonItem,
  IonText,
  IonList,
} from "@ionic/react";
import {
  getTeamTableScore,
  sortByScoreAndBreaker,
  uniqBy,
} from "services/util";

interface props {
  teams: any;
  progress: any;
  quizData: any;
}

const AggregateResults: React.FC<props> = ({ teams, progress, quizData }) => {
  const [teamStatus, setTeamStatus] = useState<any>([]);

  const score = (team: any) => {
    return getTeamTableScore(team, progress);
  };

  useEffect(() => {
    let orderedTeams = teams
      .map((team: any) => {
        return {
          teamName: team.teamName,
          score: score(team),
          breakerDiff: team.breaker?.proximity,
          breakerRank: team.breaker?.rank,
          scoreDisplay: score(team),
        };
      })
      .sort(sortByScoreAndBreaker)
      .map((team: any, i: any) => {
        return { ...team, index: i };
      });

    let firstByScore = uniqBy(orderedTeams, "score");

    firstByScore.forEach((team: any) => {
      let scoreCount = orderedTeams.filter(
        (t: any) => t.score === team.score
      ).length;

      if (team.breakerDiff !== null && team.breakerDiff >= 0 && scoreCount > 1)
        orderedTeams[team.index].scoreDisplay = team.score + "*BQ";
    });

    setTeamStatus(orderedTeams);
    //eslint-disable-next-line
  }, [teams]);

  return (
    <IonCard style={{ maxWidth: "600px" }}>
      <IonCardContent>
        <IonList>
          {teamStatus.map((team: any, i: any) => {
            return (
              <IonItem key={i} lines="full">
                <IonText
                  slot="start"
                  style={{ width: "100%", maxWidth: "70%" }}
                >
                  {team.teamName}
                </IonText>
                <IonText>{team.scoreDisplay}</IonText>
                {/* <IonText>{team.breakerDiff}</IonText>
                <IonText>{team.index}</IonText> */}
              </IonItem>
            );
          })}
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};
const mapStateToProps = (state: any) => ({
  teams: state.teams.teams,
  progress: state.quiz.progress,
  quizData: state.quiz,
});

export default connect(mapStateToProps, {})(AggregateResults);
